<template>
    <div>
      <div class="record">
        <div class="cross">
            <div>退款记录</div>
        </div>
        <table  align="center" cellpadding="10" cellspacing="5" class="table">
            <thead>
              <tr>
                <th class="w-20">支付方式</th>
                <th class="w-30">退款金额(元)</th>
                <th class="w-50">退款时间</th>
              </tr>
            </thead>
            <tbody v-for="item in RefundLists.list" :key="item.add_time">
              <tr>
                <td>{{item.channel_type| formatVar('payChannel')}}</td>
                <td>{{item.refund_fee/100}}</td>
                <td>{{item.add_time| formatTimestamp(1)}}</td>
              </tr>
            </tbody>
        </table>
          <el-pagination 
            v-if="RefundLists.list.length>5"
            background layout="prev, pager, next" class="mt-4 mb-4 text-center"
            :page-size="10" :total="RefundLists.count" :current-page=refundFormData.page 
            @current-change="v => {refundFormData.page=v;TraGroupGetRefundLists(refundFormData)}"
          />
      </div>
    </div>
  </template>
  <script>
   export default 
   {
      name: "Record",
      props:{
        oid:{
              type:Number,
              default: ''
          },
      },
      data() {
          return {
            switchTab:true,
            //退款列表
            refundFormData:{
              page:1,
              num:10,
              tid:this.oid,
            },
            RefundLists:{
                list:[]
            },
          }  
      },
      mounted() {
          this.TraGroupGetRefundLists(this.refundFormData);
      },
      methods: {
        //退款明细
        async TraGroupGetRefundLists(data){
              let resData = await this.$axios.post('/pc/Admin/RefundRecordList',data);
              this.RefundLists=resData.data;
              console.log(resData.data);
        },
      },
    }
  </script>
  <style scoped>
  .cross{
      display: flex;
      justify-content: right;
      overflow: hidden;
      width: 80%;
      margin: 0 auto;
      border-bottom: 1px #eee solid;
      padding: 12px 10%;
      background-color: #17c967;
      color: #fff;
      font-weight: bold;
      letter-spacing: 1px;
      font-size: 16px;
  }
  .cross div{
      margin: 0 auto;
  }
  .record{
    width: 100%;
    background-color: #fff;
    overflow: hidden;
  }
  .table{
    width: 94%;
    margin: 20px auto;
  }
  .table th,.table td{
    text-align: center;
    padding: 8px 0;
    border-color: rgb(235, 238, 245);
    color:#666;
  }
  .table th{
    color: #333;
    background: rgb(250, 250, 250);
  }
  .table td span{
    color: var(--smtc-color-primary); 
    cursor: pointer;
  }
  .el-icon-back{
    position: absolute;
    top: 12px;
    left: 10px;
    background-color: #fff;
    color: #17c967;
    padding: 6px 10px;
    border-radius: 15px;
    font-size: 12px;
    cursor: pointer;
  }
  .table {
    border-collapse: separate;
    border-spacing: 0;
    border-top: 1px solid #999;
    border-left: 1px solid #999;
}
.table td {
    border: 1px solid #999;
    border-top: none;
    border-left: none;
}
.table th{
    border-right: 1px solid #999;
    border-bottom: 1px solid #999;
}
  </style>